export default "__VITE_ASSET__STRVQpcS__"